import _createClass from "@babel/runtime/helpers/createClass";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
export var CrossFlowExtensions = /*#__PURE__*/_createClass(function CrossFlowExtensions(options) {
  _classCallCheck(this, CrossFlowExtensions);
  Object.assign(this, options);
  Object.freeze(this);
});